import React, { FC, Dispatch, SetStateAction } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import { Logo } from "../components/Logo";
import colors from "../constants/colors";
import MenuIcon from "@material-ui/icons/Menu";
import { store } from "../store";
import { observer } from "mobx-react-lite";
import { ToggleImperial } from "./ToggleImperial";

interface IHeaderProps {
  toggleSidebar: Dispatch<SetStateAction<boolean>>;
}

export const Header: FC<IHeaderProps> = observer(({ toggleSidebar }) => {
  const classes = styles();
  const { user } = store;

  return (
    <Box className={classes.container}>
      <Logo />
      <Box display="flex" flex={1} />
      <Box display={["none", "flex"]}>
        <ToggleImperial />
      </Box>
      {user && (
        <Box display="flex" flexDirection="column" mr={2}>
          <Typography className={classes.caption}>Signed in</Typography>
          <Typography className={classes.subtitle}>{user.email}</Typography>
        </Box>
      )}
      <MenuIcon
        className={classes.iconWrapper}
        onClick={() => toggleSidebar(true)}
      />
    </Box>
  );
});

const styles = makeStyles(() => ({
  container: {
    background: colors.grey,
    padding: 20,
    display: "flex",
    alignItems: "center",
    position: "fixed",
    width: "100%",
    height: 70,
    zIndex: 1,
  },
  iconWrapper: {
    cursor: "pointer",
  },
  caption: {
    fontSize: 11,
    color: "grey",
  },
  subtitle: {
    fontSize: 13,
  },
}));
